const HISTORY_PARAM = {
    SHOW_VALIDATE_CODE_ACTION_MODAL: 'showValidateActionModal',
} as const;

export default HISTORY_PARAM;
